import { render, staticRenderFns } from "./productionPanelList.vue?vue&type=template&id=3789fc70&"
import script from "./productionPanelList.vue?vue&type=script&lang=js&"
export * from "./productionPanelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports